import HeaderCell from "./header-cell";
import BodyCell from "./body-cell";

export const Selection = {
    Header: HeaderCell,
    Body: BodyCell,
};
